import { ViewExportType } from "@redotech/congo-enums/view-export-type";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { BaseViewSchema } from "./views";

export enum ViewExportStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}

export enum ViewExportScope {
  ALL = "all",
  SELECTED = "selected",
}

const ViewExportSchema_ = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.id.internal }),
  view: BaseViewSchema.meta({ privacy: privacy.structured }),
  exportType: createEnum(ViewExportType, { enumName: "ViewExportType" }).meta({
    privacy: privacy.enumOrStatus,
  }),
  exportScope: createEnum(ViewExportScope, {
    enumName: "ViewExportScope",
  }).meta({ privacy: privacy.enumOrStatus }),
  status: createEnum(ViewExportStatus, { enumName: "ViewExportStatus" }).meta({
    privacy: privacy.enumOrStatus,
  }),
  createdAt: z.date().meta({ privacy: privacy.timestamp }),
  updatedAt: z.date().meta({ privacy: privacy.timestamp }),
  team: zExt.objectId().meta({ privacy: privacy.id.internal }),
  user: zExt.objectId().meta({ privacy: privacy.id.internal }),
  fileUrl: z.string().nullish().meta({ privacy: privacy.privateUrl }),
  selectedDocumentIds: z
    .array(z.string())
    .nullish()
    .meta({ privacy: privacy.id.internal }),
  sendToEmail: z
    .email()
    .nullish()
    .meta({ privacy: privacy.email.merchantUser }),
  rowsProcessed: z.number().nullish().meta({ privacy: privacy.quantity }),
  totalRows: z.number().nullish().meta({ privacy: privacy.quantity }),
});

export const ViewExportSchema: z.ZodType<ViewExportSchema> = ViewExportSchema_;
export interface ViewExportSchema extends z.infer<typeof ViewExportSchema_> {}
